// @mui
import {alpha, styled} from '@mui/material/styles';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';

// ----------------------------------------------------------------------

export const StyledItem = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({active, open, depth, config, theme}) => {
  const subItem = depth !== 1;

  const activeStyles = {
    root: {
      'color': theme.palette.primary.light,
      'backgroundColor': alpha(theme.palette.primary.main, 0.16),
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.24),
      },
    },
    sub: {
      'color': '#E2E8F0',
      'backgroundColor': 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
      },
    },
  };

  return {
    // Root item
    'flexDirection': 'column',
    'justifyContent': 'center',
    'borderRadius': config.itemRadius,
    'minHeight': config.itemRootHeight,
    'color': '#FFFFFF',
    'margin': `0 ${config.itemGap}px ${config.itemGap}px ${config.itemGap}px`,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
    ...(config.hiddenLabel &&
      !subItem && {
      padding: config.itemPadding,
    }),

    // Active root item
    ...(active && {
      ...activeStyles.root,
    }),

    // Sub item
    ...(subItem && {
      margin: 0,
      flexDirection: 'row',
      padding: theme.spacing(0, 1),
      minHeight: config.itemSubHeight,
      // Active sub item
      ...(active && {
        ...activeStyles.sub,
      }),
    }),

    // Open
    ...(open &&
      !active && {
      color: '#FFFFFF',
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    }),
  };
});

// ----------------------------------------------------------------------

export const StyledIcon = styled(ListItemIcon)(({size}) => ({
  width: size,
  height: size,
  marginRight: 0,
  color: 'inherit',
}));
